// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1Vt8i","list":"BalanceDue_list__1WIX1","listRow":"BalanceDue_listRow__2JWnE","total":"BalanceDue_total__3pkC2"};